module.exports = __webpack_public_path__ + "img/a.d2cb1b50.png";